import { render } from "./ToAdmin.vue?vue&type=template&id=3b82b91e"
import script from "./ToAdmin.vue?vue&type=script&lang=js"
export * from "./ToAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__